var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const sizeMap = {
    large: 18,
    medium: 16,
    small: 14,
    tiny: 10,
    xlarge: 24,
    xsmall: 12,
};
function IconInternal(_a) {
    var { children, size = 'medium' } = _a, restProps = __rest(_a, ["children", "size"]);
    const numericSize = sizeMap[size];
    return (_jsx("svg", Object.assign({ "aria-hidden": "true", height: numericSize, width: numericSize }, restProps, { children: children })));
}
export default IconInternal;
